import React, { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Users, Activity, Settings, LogOut, Bell, Search, Menu, X, Wallet, ChevronRight, Moon, Mail, CreditCard } from 'lucide-react';
import logo from '../../assets/AlgoLogo.png';

const AdminLayout: React.FC = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false); // Mobile pe default close rahega
  const navigate = useNavigate();

const handleLogout = () => {
  localStorage.removeItem("motilal_admin_token");
  navigate('/moti-lal'); // Wapas login var
};

const navItems = [
  { name: 'Dashboard', path: '/moti-lal/dashboard', icon: <LayoutDashboard size={20} /> },
  { name: 'Customer Mgmt', path: '/moti-lal/customers', icon: <Users size={20} /> }, 
  { name: 'Add Transaction', path: '/moti-lal/add-transaction', icon: <CreditCard size={20} /> },
  { name: 'Active Algos', path: '/moti-lal/algos', icon: <Activity size={20} /> },
  { name: 'Set Portfolio', path: '/moti-lal/set-portfolio', icon: <Wallet size={20} /> },
  { name: 'Trading History', path: '/moti-lal/trading-history', icon: <Activity size={20} /> },
  { name: 'Set Withdrawal', path: '/moti-lal/set-withdrawal', icon: <CreditCard size={20} /> },
  // { name: 'Settings', path: '/moti-lal/settings', icon: <Settings size={20} /> },

];
  return (
    <div className="flex h-screen bg-[#f8f9fc] font-[Urbanist] overflow-hidden">
      
      {/* Mobile Sidebar Overlay */}
      {isSidebarOpen && (
        <div 
          className="fixed inset-0 bg-black/50 z-30 lg:hidden backdrop-blur-sm"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

      {/* SIDEBAR */}
      <aside className={`fixed lg:static inset-y-0 left-0 z-40 bg-white flex flex-col w-64 lg:w-64 transition-transform duration-300 ease-in-out ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'} shadow-[4px_0_24px_rgba(0,0,0,0.04)]`}>
        
        {/* Top Dark Section (Matching Image) */}
        <div className="bg-[#2d2780] text-white p-6 rounded-br-[2.5rem]">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 bg-white rounded-xl flex items-center justify-center shadow-lg overflow-hidden">
  <img 
    src= {logo} 
    alt="logo" 
    className="w-full h-full object-cover"
  />
</div>
             <h1 className="text-2xl font-black tracking-wide">Motilal Algo</h1>
          </div>
          
         
           {/* Mock Wallet Card */}
         <div className="bg-white/10 p-4 rounded-xl backdrop-blur-md border border-white/10">
  <div className="flex items-center gap-3">
    <div className="w-10 h-10 flex items-center justify-center">
      📈
    </div>
    <div>
      <p className="text-xl font-bold text-green-300">+₹12,540</p>
      <p className="text-xs text-green-200">Today's Profit</p>
    </div>
  </div>
</div>
        
        </div>

        <div className="px-4 py-6 flex-1 overflow-y-auto">
          <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-4 px-3">Main Menu</p>
          <nav className="space-y-1">
            {navItems.map((item) => (
              <NavLink
                key={item.name}
                to={item.path}
                className={({ isActive }) =>
                  `flex items-center justify-between px-4 py-3 rounded-xl transition-all duration-200 group ${
                    isActive 
                      ? 'bg-[#3b36a4] text-white shadow-md shadow-indigo-500/20' 
                      : 'text-slate-500 hover:bg-indigo-50 hover:text-[#3b36a4]'
                  }`
                }
              >
                <div className="flex items-center gap-3">
                  <div className={`${({isActive}: any) => isActive ? 'text-white' : 'text-slate-400 group-hover:text-[#3b36a4]'}`}>
                    {item.icon}
                  </div>
                  <span className="font-semibold text-[15px]">{item.name}</span>
                </div>
                <ChevronRight size={16} className="opacity-0 group-hover:opacity-100 transition-opacity" />
              </NavLink>
            ))}
          </nav>
        </div>

        <div className="p-4 border-t border-slate-100">
          <button 
            onClick={handleLogout}
            className="flex items-center gap-3 px-4 py-3 w-full rounded-xl text-slate-500 hover:bg-red-50 hover:text-red-600 transition-colors font-bold text-[15px]"
          >
            <LogOut size={20} /> Logout
          </button>
        </div>
      </aside>

      {/* MAIN CONTENT */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden relative">
        
        {/* HEADER (Dark Blue like image) */}
        <header className="h-20 bg-[#2d2780] text-white flex items-center justify-between px-4 lg:px-8 z-10">
          <div className="flex items-center gap-4 w-full lg:w-auto">
            <button 
              onClick={() => setIsSidebarOpen(true)}
              className="lg:hidden text-white hover:bg-white/10 p-2 rounded-lg transition-colors"
            >
              <Menu size={24} />
            </button>
            
            <div className="relative w-full lg:w-96">
              <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-white/50" size={18} />
              <input 
                type="text" 
                placeholder="Search here..." 
                className="w-full pl-11 pr-4 py-2.5 bg-white/10 border border-white/10 rounded-full text-sm font-medium text-white placeholder-white/50 focus:ring-2 focus:ring-white/30 outline-none transition-all"
              />
            </div>
          </div>

          <div className="hidden lg:flex items-center gap-6">
            <div className="flex items-center gap-4">
              <button className="text-white/80 hover:text-white transition-colors bg-white/10 p-2.5 rounded-full"><Moon size={18} /></button>
              <button className="relative text-white/80 hover:text-white transition-colors bg-white/10 p-2.5 rounded-full">
                <Bell size={18} />
                <span className="absolute top-0 right-0 w-2.5 h-2.5 bg-red-500 rounded-full border-2 border-[#2d2780]"></span>
              </button>
              <button className="text-white/80 hover:text-white transition-colors bg-white/10 p-2.5 rounded-full"><Mail size={18} /></button>
            </div>

            <div className="flex items-center gap-3 pl-6 border-l border-white/20">
              <div className="text-right">
                <p className="text-sm font-bold text-white leading-tight">James Supardi</p>
                <p className="text-[11px] font-medium text-blue-200">@motilal_admin</p>
              </div>
              <img src="https://ui-avatars.com/api/?name=James+Supardi&background=ffffff&color=2d2780" alt="Admin" className="w-10 h-10 rounded-full border-2 border-white/20" />
            </div>
          </div>
        </header>

        {/* PAGE CONTENT */}
        <main className="flex-1 overflow-y-auto p-4 lg:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;